import moment from 'moment';
import {
  CELL_HEIGHT,
  ONE_MIN_OFFSET,
} from '../../components/ProviderCalendar/constants';

const DEFAULT_OFFSET = 8 * 4 * CELL_HEIGHT;

export function calculateOffsetTop(slots = []) {
  if (slots.length === 0) return DEFAULT_OFFSET;

  let minStartTime = slots[0].scheduleSetting.startTime;

  slots.forEach(({ scheduleSetting: { startTime } }) => {
    if (moment.utc(startTime).isSameOrBefore(moment.utc(minStartTime))) {
      minStartTime = startTime;
    }
  });

  const diff = moment
    .utc(moment.utc(minStartTime).format('HH:mm'), 'HH:mm')
    .diff(moment.utc('00:00', 'HH:mm'));

  if (diff < 0) return DEFAULT_OFFSET;

  return diff / (1000 * 60 * ONE_MIN_OFFSET);
}



// WEBPACK FOOTER //
// ./src/utils/schedule/offset-calculation.js